import { createStorageSlice } from './slice';

export const logoStorageSlice = createStorageSlice('qbp-logos');
